import { startupMark } from "./components/360/startup/marks";
import "./index.css";
import {
  isStandaloneRoute,
  watchEntryMode,
} from "./components/360/startup/standalone";
import { afterFirstPaint } from "./components/360/startup/firstPaint";
import { usedHere, warmAppModules } from "./components/360/startup/warmModules";
import { bootFailure } from "./components/360/startup/bootFailure";

// Public recipients never initialize authentication, native calling, app updates,
// or the workspace data provider. Both paths are independent Vite entry chunks.
startupMark("entry-start");
watchEntryMode();
// The launch screen paints before the app's code starts downloading, so on a slow
// phone network the first frame never waits behind several hundred KB of scripts.
void afterFirstPaint()
  .then(() =>
    isStandaloneRoute(window.location)
      ? import("./public-main")
      : (warmAppModules(usedHere()), import("./app-main")),
  )
  .catch(bootFailure);
